import { ranking } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <div className="w-1.5 h-6 rounded-full bg-accent-500"></div>
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">人气榜单</h2>
          </div>
          <span className="text-xs text-foreground-400 bg-background-100 px-2.5 py-1 rounded-full whitespace-nowrap">本周TOP5</span>
        </div>

        <div className="space-y-3">
          {ranking.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 bg-background-100 rounded-xl p-4 md:p-5 hover:bg-background-200/70 transition-colors cursor-pointer"
            >
              <div className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center text-lg font-bold font-heading ${
                item.rank === 1 ? 'bg-accent-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="w-14 h-14 md:w-16 md:h-16 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">{item.title}</h3>
                  <span className="text-xs text-foreground-400 bg-background-200 px-2 py-0.5 rounded whitespace-nowrap">{item.tag}</span>
                </div>
                <p className="text-xs md:text-sm text-foreground-600 line-clamp-1">{item.desc}</p>
              </div>

              <div className="flex-shrink-0 hidden sm:block">
                <span className="text-xs text-foreground-400 bg-background-200 px-3 py-1.5 rounded-lg whitespace-nowrap cursor-pointer hover:bg-primary-100 hover:text-primary-700 transition-colors">
                  立即阅读
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}